import { mode, StyleFunctionProps } from "@chakra-ui/theme-tools";

export default {
  global: (props: StyleFunctionProps) => ({
    body: {
      color: "default",
      bg: "bg-canvas",
    },
    // Placeholders are examples, not values: `subtle` (gray.500 / gray.400,
    // ~4.8:1 and ~5.3:1 on the input) sits well below typed text (~18:1)
    // while staying legible. `muted` read almost like a filled-in value.
    "*::placeholder": {
      opacity: 1,
      color: "subtle",
    },
    "*, *::before, &::after": {
      borderColor: mode("gray.200", "gray.800")(props),
    },
    "html,body": {
      height: "100%",
    },
    html: {
      scrollBehavior: "smooth",
    },
    "#__next, #root": {
      display: "flex",
      flexDirection: "column",
      minH: "100%",
    },
  }),
};
